import { createReducer, on } from '@ngrx/store';
import * as LayoutActions from '../_actions/layout.actions';

export const layoutFeatureKey = 'layout';

export interface LayoutState {
	bottomBar: {
		visible: boolean,
		instantToggle: boolean
	};
	floatingSidebar: {
		visible: boolean;
	};
	header: {
		patientCardVisible: boolean;
		infosVisible: boolean;
		warningsVisible: boolean;
	};
	splashVisible: boolean;
	footer: {
		footerVisible: boolean;
	};
}

export const initialState: LayoutState = {
	bottomBar: {
		visible: false,
		instantToggle: false
	},
	floatingSidebar: {
		visible: false
	},
	header: {
		patientCardVisible: false,
		infosVisible: true,
		warningsVisible: false
	},
	splashVisible: false,
	footer: {
		footerVisible: false
	}
};

export const layoutReducer = createReducer<LayoutState>(
	initialState,
	on(LayoutActions.toggleBottomBar, state => ({
		...state,
		bottomBar: { ...state.bottomBar, visible: !state.bottomBar.visible }
	})),
	on(LayoutActions.closeBottomBar, state => ({
		...state,
		bottomBar: { ...state.bottomBar, visible: false }
	})),
	on(LayoutActions.openBottomBar, state => ({
		...state,
		bottomBar: { ...state.bottomBar, visible: true }
	})),
	on(LayoutActions.changeInstantToggleBottomBar, state => ({
		...state,
		bottomBar: { ...state.bottomBar, instantToggle: !state.bottomBar.instantToggle }
	})),
	on(LayoutActions.toggleFloatingSidebar, state => ({
		...state,
		floatingSidebar: { ...state.floatingSidebar, visible: !state.floatingSidebar.visible }
	})),
	on(LayoutActions.closeFloatingSidebar, state => ({
		...state,
		floatingSidebar: { ...state.floatingSidebar, visible: false }
	})),
	on(LayoutActions.togglePatientCard, state => ({
		...state,
		header: { ...state.header, patientCardVisible: !state.header.patientCardVisible }
	})),
	on(LayoutActions.closePatientCard, state => ({
		...state,
		header: { ...state.header, patientCardVisible: false }
	})),
	on(LayoutActions.showInfos, state => ({
		...state,
		header: {
			...state.header,
			infosVisible: true,
			warningsVisible: false
		}
	})),
	on(LayoutActions.showWarnings, state => ({
		...state,
		header: {
			...state.header,
			infosVisible: false,
			warningsVisible: true
		}
	})),
	on(LayoutActions.showSplash, state => ({
		...state,
		splashVisible: true
	})),
	on(LayoutActions.hideSplash, state => ({
		...state,
		splashVisible: false
	})),
	on(LayoutActions.toggleFooter, state => ({
		...state,
		footer: { ...state.footer, footerVisible: !state.footer.footerVisible }
	})),
);
